<template>
    <b-modal
        id="eft-modal"
        title="EFT Payment Required"
        ok-title="Confirm"
        cancel-title="Cancel"
        @ok="onConfirm"
        centered
    >
        <div class="mb-3">
            <p>
                Please make an EFT payment to the following bank account:
            </p>
            <b-card bg-variant="light" class="mb-2">
                <ul class="list-unstyled mb-0">
                    <li><strong>Bank:</strong> {{ siteConfig.bank_name }}</li>
                    <li><strong>Account Number:</strong> {{ siteConfig.account_number }}</li>
                    <li><strong>Branch Code:</strong> {{ siteConfig.branch_code }}</li>
                    <li><strong>Reference:</strong> {{ orderNumber }}</li>
                    <li>
                        <strong style="color: #d9534f; font-size: 1.2em;  padding: 4px 0px; border-radius: 4px;">
                            Total Due: R{{ orderTotal }}
                        </strong>
                    </li>
                </ul>
            </b-card>
            <p>
                Once payment is made, please email your proof of payment to:
                <b-link :href="`mailto:${siteConfig.accounts_email}`">{{ siteConfig.accounts_email }}</b-link>
            </p>
        </div>
    </b-modal>
</template>

<script>
import {
    adminComputed
} from "@/state/helpers";
export default {
    name: "EftModal",
    computed: {
        ...adminComputed,
        siteConfig() {
            return this.core.site_config;
        }  
    },
    props: {
        orderNumber: String,
        orderTotal: String
    },
    methods: {
        onConfirm() {
            this.$bvModal.hide('eft-modal');
            this.$router.go(-1);
        },
    }
};
</script>

<style scoped>
/* Optional: Add custom styles if needed */
</style>